import { GET_NOTICE, LIST_NOTICE } from '../actions/types';

const initialState = {
  notice: null,
  notices: {
    count: 0,
    rows: [],
  },
};

const notices = (state = initialState, action) => {
  switch (action.type) {
    case GET_NOTICE:
      return {
        ...state,
        notice: action.payload,
        notices: initialState.notices,
      };
    case LIST_NOTICE:
      return {
        ...state,
        notices: action.payload,
        notice: initialState.notice,
      };
    default:
      return state;
  }
};

export default notices;
